import {
  HttpBackend,
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import axios from 'axios';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Channel } from '../models/channel.model';
import { AuthService } from './auth.service';
import { UtilsService } from './utils.service';
@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService,
    private handler: HttpBackend
  ) {}

  async getChannel(uid: string): Promise<Observable<any>> {
    try {
      const baseParams = new HttpParams().set('uid', uid);
      return this.utilsService.setHttpHeaders(false).then((headers) => {
        return this.http.get(environment['AWS_CHANNEL_FETCH']!, {
          params: baseParams,
          headers: headers,
        });
      });
    } catch (error) {
      console.error(`Error fetching channel: ${error}`);
      throw { message: `Error fetching channel: ${error}` };
    }
  }

  async getPresignedUrl(
    fileExtn: string,
    uid: string,
    channel: Channel
  ): Promise<any> {
    try {
      const idToken = await this.authService.getToken();
      // console.log('idToken', idToken);
      if (!idToken) {
        return null;
      }
      return axios.get(environment['AWS_CHANNEL_IMAGE_SIGNEDURL']!, {
        timeout: 10000,
        params: {
          fileExtension: fileExtn,
          id: channel.id,
        },
        headers: {
          'x-api-key': environment['AWS_API_KEY']!,
          'Access-Control-Allow-Origin': '*',
          AuthorizationToken: `Bearer ${idToken}`,
          'x-amz-meta-name': channel.name,
          'x-amz-meta-uid': channel.createdById!,
          'x-amz-meta-aspectratio': (
            channel?.imageAspectRatio ?? '1'
          ).toString(),
        },
      });
    } catch (error) {
      console.error(`Error fetching presignedUrl: ${error}`);
      throw { message: `Error fetching presignedUrl: ${error}` };
    }
  }

  // getPresignedUrl(
  //   fileExtn: string,
  //   uid: string,
  //   channel: Channel
  // ): Observable<any> {
  //   try {
  //     return from(this.authService.getToken()).pipe(
  //       take(1),
  //       map((idToken) => {
  //         console.log('idToken', idToken);
  //         return axios.get(environment['AWS_CHANNEL_IMAGE_SIGNEDURL']!, {
  //           timeout: 10000,
  //           params: {
  //             fileExtension: fileExtn,
  //             id: channel.id,
  //           },
  //           headers: {
  //             'x-api-key': environment['AWS_API_KEY']!,
  //             'Access-Control-Allow-Origin': '*',
  //             AuthorizationToken: `Bearer ${idToken}`,
  //             'x-amz-meta-name': channel.name,
  //             'x-amz-meta-uid': channel.createdById!,
  //             'x-amz-meta-aspectratio': (
  //               channel?.imageAspectRatio ?? '1'
  //             ).toString(),
  //           },
  //         });
  //       })
  //     );
  //   } catch (error) {
  //     console.error(`Error fetching presignedUrl: ${error}`);
  //     throw { message: `Error fetching presignedUrl: ${error}` };
  //   }
  // }

  // async getPresignedUrl(
  //   fileExtn: string,
  //   uid: string,
  //   channel: Channel
  // ): Promise<string> {
  //   try {
  //     const idToken = await this.authService.getToken();
  //     console.log('idToken', idToken);
  //     const response = await axios.get(
  //       environment['AWS_CHANNEL_IMAGE_SIGNEDURL']!,
  //       {
  //         timeout: 10000,
  //         params: {
  //           fileExtension: fileExtn,
  //           id: channel.id,
  //         },
  //         headers: {
  //           'x-api-key': environment['AWS_API_KEY']!,
  //           'Access-Control-Allow-Origin': '*',
  //           AuthorizationToken: `Bearer ${idToken}`,
  //           'x-amz-meta-name': channel.name,
  //           'x-amz-meta-uid': channel.createdById!,
  //           'x-amz-meta-aspectratio': (
  //             channel?.imageAspectRatio ?? '1'
  //           ).toString(),
  //         },
  //       }
  //     );
  //     return response.data.imageUrl;
  //   } catch (error) {
  //     console.error(`Error fetching presignedUrl: ${error}`);
  //     throw { message: `Error fetching presignedUrl: ${error}` };
  //   }
  // }

  // uploadImage(file: File, presignedUrl: string): Observable<number> {
  //   from(
  //     axios.postForm(presignedUrl, file, {
  //       onUploadProgress: function (axiosProgressEvent) {
  //         return of(axiosProgressEvent.progress);
  //       },
  //     })
  //   );
  // }

  uploadImage(url: string, file: File): Observable<HttpEvent<{}>> {
    this.http = new HttpClient(this.handler); // to reset the header
    const headers = new HttpHeaders({ 'Content-Type': file.type });
    const req = new HttpRequest('PUT', url, file, {
      headers: headers,
      reportProgress: true,
    });
    return this.http.request(req);
  }

  async createChannel(channel: Channel): Promise<Channel> {
    const idToken = await this.authService.getToken();
    try {
      return this.utilsService
        .setAxiosHeaders(true)
        .then(async (baseHeaders) => {
          return axios
            .put(environment['AWS_CHANNEL_CREATE']!, channel, {
              headers: baseHeaders,
            })
            .then((response) => {
              return response.data;
            });
        });
    } catch (error) {
      throw { message: `Error creating channel: ${error}` };
    }
  }

  async updateChannel(channel: Channel): Promise<Observable<Channel>> {
    const idToken = await this.authService.getToken();
    try {
      return this.utilsService
        .setHttpHeaders(true, 'PUT')
        .then(async (baseHeaders) => {
          return this.http.put<Channel>(
            environment['AWS_CHANNEL_UPDATE']!,
            channel, // Wrap the channel object in an Observable using the of operator
            { headers: baseHeaders }
          );
        });
    } catch (error) {
      throw { message: `Error updating channel: ${error}` };
    }
  }

  async checkAvailability(name: string): Promise<boolean> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      try {
        const response = await axios.get(environment['AWS_CHANNEL_EXISTS']!, {
          params: { channelName: name },
          headers: headers,
        });
        const isUnique: boolean =
          response.data['exists'] != null && !response.data['exists']
            ? true
            : false;
        return isUnique;
      } catch (error) {
        throw { message: `Error checking availability: ${error}` };
      }
    });
  }

  async delete(id: string) {
    //   return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
    //     return axios
    //       .delete(environment['AWS_CHANNEL_DELETE']!, {
    //         params: { id: id },
    //         headers: headers,
    //       })
    //       .catch((error) => {
    //         throw error;
    //       })
    //       .then((response) => {
    //         return id;
    //       });
    //   });
  }
}
